import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { IMG } from "@/lib/imagery";
import VideoEmbed from "@/components/VideoEmbed";
import Seo from "@/components/Seo";

export default function InsightArticle() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/insights/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="p-24 text-center text-[color:var(--ink-muted)]">Loading…</div>;
  if (!post) return <div className="p-24 text-center text-[color:var(--ink-muted)]">Article not found.</div>;

  return (
    <article className="mx-auto max-w-3xl px-5 py-14 lg:py-20">
      <Seo title={post.title} description={post.excerpt || (post.body || "").slice(0, 155)} image={post.cover_image} type="article" />
      <Link to="/insights" className="inline-flex items-center gap-1.5 text-xs text-[color:var(--ink-muted)] hover:text-[color:var(--evergreen)]">
        <ArrowLeft size={12} /> All insights
      </Link>
      <p className="overline mt-6">{post.author}</p>
      <h1 data-testid="insight-article-title" className="mt-3 font-editorial text-4xl font-semibold leading-tight tracking-tight text-[color:var(--ink)] sm:text-5xl">
        {post.title}
      </h1>
      {post.cover_image && (
        <div className="photo-vignette mt-8 h-[300px] lg:h-[420px]">
          <img src={post.cover_image || IMG.charts} alt="" className="h-full w-full object-cover" />
        </div>
      )}
      {post.video_url && <div className="mt-8"><VideoEmbed url={post.video_url} /></div>}
      <div className="prose-edge mt-8">
        {(post.body || "").split("\n").filter(Boolean).map((para, i) => <p key={i}>{para}</p>)}
      </div>
    </article>
  );
}
